<template>
    <div>
        <h3 class="popup-tilte">Erre a kockázatviselési címre már készült kalkuláció!</h3>
        <div>Az alábbi felhasználók készítettek kalkulációt:</div>
        <div>{{ usernames }}</div>
        <div>Biztosan folytatod?</div>
        <div class="d-flex">
            <LoadingButton
                class="navBtn-next btn btn-blue mx-auto"
                text="Tovább"
                @click="handleCancel"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import LoadingButton from '@/components/elements/LoadingButton';

export default {
    components: {
        LoadingButton,
    },
    computed: {
        ...mapGetters(['getMatchingRealEstateUsers']),
        usernames() {
            return this.getMatchingRealEstateUsers.filter(e => e.user !== null).map(e => e.user?.name).join(' ,');
        },
    },
    methods: {
        ...mapMutations(['showPopup']),
        async handleCancel() {
            this.showPopup(null);
        }

    },
};
</script>
